// Plan (Google Earth) ⟷ pitched (true) lengths. Mirrors backend services/roof_geometry.py.
export const PITCHED_PIN_TYPES = ['Hip', 'Valley', 'Barge', 'Flashing', 'Length'];

const VERBAL = [['very steep', 53], ['steep', 37], ['medium', 18.5], ['flat', 4]];

// Roof Angle (measured) first, else the Pitch range midpoint.
export function pitchFromRoof(roof) {
  const a = parseFloat(roof?.roof_angle);
  if (a > 0) return a;
  const v = String(roof?.roof_pitch || '').toLowerCase();
  const hit = VERBAL.find(([k]) => v.includes(k));
  if (hit) return hit[1];
  const n = parseFloat(v);
  return n > 0 && n < 90 ? n : null;
}

export function pitchedFactor(kind, deg) {
  if (!(deg > 0 && deg < 89)) return null;
  const r = (deg * Math.PI) / 180;
  return ['hip', 'valley'].includes(String(kind || '').toLowerCase())
    ? Math.sqrt(1 + Math.tan(r) ** 2 / 2)
    : 1 / Math.cos(r);
}

const round2 = (n) => Math.round(n * 100) / 100;
export const toPitched = (plan, kind, deg) => { const f = pitchedFactor(kind, deg); return f && plan > 0 ? round2(plan * f) : null; };
export const toPlan = (pitched, kind, deg) => { const f = pitchedFactor(kind, deg); return f && pitched > 0 ? round2(pitched / f) : null; };
